import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: {
    en: {
      Add: 'Add',
      Save: 'Edit',
      login: {
        header: 'Login',
        password: 'Password',
        twoFactorCode: '6 Digit code',
        submit: 'Submit',
      },
      initiative: {
        list: {
          header: 'Initiatives',
          add: 'Add initiative',
        },
        edit: {
          header: 'Edit Shift initiative',
          intro:
            'Add the initiative here, by providing the name. Then click "save" to get the URL which you can share with others so that the content can be added.',
          index: '#',
          name: 'Name',
          nameHint: 'The name of the initiative',
          description: 'Description',
          descriptionHint:
            'A description of the initiative. What do they do, why should people visit',
          quizTitle: 'Teaser title',
          quizTitleHint: 'A teaser title for the initiative',
          website: 'Website URL',
          websiteHint:
            'The URL of the website of the initiative. Can also be a page on another website',
          area: 'Area',
          areaHint: 'The area where the initiative is active',
          area_local: 'Local',
          area_national: 'National',
          area_global: 'Global / Online',
          shortDescription: 'Short description',
          shortDescriptionHint:
            'The short description is used to promote the initiative in the app in certain places',
          mainCategory: 'Main category',
          id: 'ID',
          title: 'Name',
          category: 'Category',
          share: 'Share URL',
          sharing: 'Sharing',
          state: 'State',
          save: 'Save',
          required: 'This field is required',
          created: 'The initiative has been added',
          ok: 'Ok',
          created_intro1:
            'The initiative has now been created. More information is required. You can find this by clicking the name in the list.',
          created_intro2:
            'The fields must be entered in two languages. You can see which translations need to be translated on the page where you edit the initiative.',
          created_intro3:
            "You can also share the URL for editing the initiative with people. They don't need to log in.",
          created_intro4:
            'Once it\'s finished, the initiative\'s status will change to "Review." You can then forward it to Shift.',
          readyForReview: 'Ready for review',
          readyForPublishing: 'Ready for Shift Review',
          editing: 'Back to editing',
          status_editing: 'Editing',
          status_review: 'Review',
          status_review_long: 'Ready for review',
          status_publishing: 'Shift Review',
          status_publishing_long: 'Ready for Shift review',
          status_published: 'Published',
          status_user_published: 'Conten Editor Published',
          contact: 'Contact',
          contacts: 'Contact | Contacts',
          addContact: 'Add contact',
          firstname: 'First name',
          lastname: 'Last name',
          email: 'E-mail',
          main: 'Main',
          url: 'URL',
          phone: 'Phone',
          language: 'Language',
          alternative: 'Alternative address',
          addresses: 'Address | Addresses',
          addAddress: 'Add address',
          street: 'Street',
          housenumber: 'Housenumber',
          extra: 'Extra',
          neighbourhood: 'Neighbourhood',
          postalcode: 'Postal code',
          city: 'City',
          country: 'Country',
          exact: 'Exact',
          radius: 'Radius',
          title_translation:
            'The name of the initiative is missing a translation.',
          quiztitle_translation: 'The teaser title is missing a translation',
          shortDescription_translation:
            'The short description is missing a translation',
          description_translation: 'The description is missing a translation',
          media_translation:
            'The description of an image is missing a translation',
          media_main: 'A "main" image will have to be added',
          media_background: 'A background image will have to be added',
          categories: 'Categories',
          media: 'Media',
          mediaEdit: 'Edit media',
          mediaNone: 'There are no media associated with this object.',
          mediaSave: 'Save the object to save the connection to the media',
          mediaRequired: 'This object needs the following media: {list}',
          image_background_image: 'Background image',
          image_main: 'Main image',
        },
        help: {
          descriptionHeader: 'Edit text',
          descriptionText1:
            'The description will be saved as "Markdown". This means that specific formatting will be used for bold text, lists, and also images and links. It\'s best to use the toolbar to accomplish this.',
          categoryHeader: 'Choose category',
          categoryText1:
            'Choose a category for the initiative here. Choose a subcategory, not a main category. The categories are listed with "Main - Sub - Sub" names.',
          categoryText2:
            "You can select multiple categories, but this isn't necessary. The main category will be calculated based on this selection. ",
          addressHeader: 'Address',
          addressText1:
            'This address is where people can visit for the initiative.',
          addressText2:
            'Multiple addresses can be entered if the initiative is active at multiple addresses.',
          contactHeader: 'Contact',
          contactText1:
            'Contact persons are not listed in the app. This is for Shift to use to contact them if necessary. Multiple persons can be specified, or just a general email address or website address.',
          mediaHeader: 'Images',
          mediaText1:
            'The app requires two images to be displayed with the initiative. The app distinguishes between image 1 and image 2 based on the "purpose" of the image. You can specify this when uploading/adding.',
          mediaText2:
            'You can also add additional images using the purpose "content"; these can be used in the description.',
          mediaText3:
            'You can also use the same image for "Main" and "Background" by uploading it once and searching for the image the second time.',
        },
      },
      media: {
        add: 'Add',
        edit: 'Edit',
        save: 'Save',
        upload: 'Upload',
        search: 'Search',
        uploadNew: 'Upload new file',
        description: 'Description',
        language: 'Language',
        purpose: 'Use',
        all: 'All',
        use: 'Use',
        view: 'View',
        editShort: 'Edit',
        remove: 'Remove',
        cancel: 'Close',
        uploadOrSearch:
          'You can upload a new image, or use the search function to use existing images in the CMS.',
      },
    },
    nl: {
      Add: 'Voeg toe',
      Save: 'Bewerk',
      login: {
        header: 'Inloggen',
        password: 'Wachtwoord',
        twoFactorCode: '6 nummer code',
        submit: 'Versturen',
      },
      initiative: {
        list: {
          header: 'Initiatieven',
          add: 'Initiatief toevoegen',
        },
        edit: {
          header: 'Shift Initiatief bewerken',
          intro:
            'Voeg het initiatief hier toe, door de naam in te voeren. Klik dan op "opslaan" om de URL te krijgen die je kan delen met anderen zodat de content ingevoerd kan worden.',
          index: '#',
          name: 'Naam',
          nameHint: 'De naam van het initiatief',
          description: 'Omschrijving',
          descriptionHint:
            'Een omschrijving van het initiatief. Wat doen ze, en waarom zouden mensen langs moeten gaan.',
          quizTitle: 'Teaser titel',
          quizTitleHint: 'Een teaser titel voor het initiatief',
          website: 'Website URL',
          websiteHint:
            'De URL van de website van het initiatief. Dit kan ook een pagina zijn op een andere website',
          area: 'Gebied',
          areaHint: 'Het gebied waar het initiatief actief is',
          area_local: 'Lokaal',
          area_national: 'Nationaal',
          area_global: 'Globaal / Online',
          shortDescription: 'Korte omschrijving',
          shortDescriptionHint:
            'De korte omschrijving wordt gebruikt om het initiatief te introduceren op plekken in de app',
          mainCategory: 'Hoofd categorie',
          id: 'ID',
          title: 'Naam',
          category: 'Categorie',
          share: 'Deel URL',
          sharing: 'Delen',
          state: 'Status',
          save: 'Opslaan',
          required: 'Dit veld is verplicht',
          created: 'Het initiatief is toegevoegd',
          ok: 'Ok',
          created_intro1:
            'Het initiatief is nu aangemaakt. Er is meer informatie nodig om in te vullen. Je kan dat vinden door in de lijst op de naam te klikken. ',
          created_intro2:
            'De velden moeten in twee talen worden ingevoerd. Welke vertalen vertaald moeten worden kan je zien op de pagina waar je het initiatief bewerkt',
          created_intro3:
            'Je kan de URL om het initiatief te bewerken ook delen met mensen. Ze hoeven niet in te loggen.',
          created_intro4:
            'Als het klaar is zal de status van het initiatief naar "Controle" gaan. Dan kan je het doorsturen naar Shift.',
          editing: 'Terug naar bewerken',
          readyForReview: 'Klaar voor controle',
          readyForPublishing: 'Klaar voor vrijgeven',
          status_editing: 'Bewerken',
          status_review: 'Controle',
          status_review_long: 'Klaar voor controle',
          status_publishing: 'Shift controle',
          status_publishing_long: 'Klaar voor Shift controle',
          status_published: 'Gepubliceerd',
          status_user_published: 'Conten Editor Gepubliceerd',
          contact: 'Contact',
          contacts: 'Contact | Contacts',
          addContact: 'Contact toevoegen',
          firstname: 'Voornaam',
          lastname: 'Achternaam',
          email: 'E-mail',
          main: 'Eerste',
          url: 'URL',
          phone: 'Telefoon',
          language: 'Taal',
          alternative: 'Alternatief adres',
          addresses: 'Adres | Adressen',
          addAddress: 'Adres toevoegen',
          street: 'Straat',
          housenumber: 'Nummer',
          extra: 'Extra',
          neighbourhood: 'Wijk',
          postalcode: 'Postcode',
          city: 'Stad',
          country: 'Land',
          exact: 'Exact',
          radius: 'Radius',
          title_translation: 'De naam van het initiatief mist een vertaling.',
          quiztitle_translation: 'De teaser titel mist een vertaling',
          shortDescription_translation:
            'De korte omschrijving mist een vertaling',
          description_translation: 'De omschrijving mist een vertaling',
          media_translation:
            'De omschrijving van een plaatje mist een vertaling',
          media_main: 'Een "main" plaatje moet nog worden toegevoegd',
          media_background:
            'Een achtergrond plaatje moet nog worden toegevoegd',
          categories: 'Categorieën',
          media: 'Plaatjes',
          mediaEdit: 'Plaatjes bewerken',
          mediaNone: 'Er zijn geen plaatjes aan dit object gekoppeld.',
          mediaSave:
            'Sla het object op om de verbinding met de plaatjes te behouden.',
          mediaRequired: 'Dit object heeft de volgende plaatjes nodig: {list}',
          image_background_image: 'Achtergrond plaatje',
          image_main: 'Main plaatje',
        },
        help: {
          descriptionHeader: 'Tekst bewerken',
          descriptionText1:
            'De omschrijving wordt opgeslagen als "Markdown". Dit betekend dat er bepaalde formatting wordt gebruikt voor dikgedrukte text, lijstjes, en ook plaatjes en links. Je kan het beste de toolbar gebruiken om dit voor elkaar te krijgen.',
          categoryHeader: 'Categorie kiezen',
          categoryText1:
            'Kies hier een categorie voor het initiatief. Kies een sub-category, en geen hoofd categorie. De categorieën worden vermeld met "Hoofd - Sub - Sub" namen.',
          categoryText2:
            'Je kan meerdere categorieën kiezen, maar dit is niet nodig. De hoofd categorie wordt aan de hand van deze keuze hier berekend. ',
          addressHeader: 'Adres',
          addressText1:
            'Dit adres is waar mensen langs kunnen komen voor het initiatief.',
          addressText2:
            'Meerdere adressen kunnen worden ingevoerd wanneer het initiatief op meerdere adressen actief is.',
          contactHeader: 'Contact',
          contactText1:
            'Contact personen worden niet vermeld in de app. Dit is voor Shift om te gebruiken om eventueel contact op te nemen. Meerdere personen kunnen worden opgegeven, of ook alleen een algemeen email adres of web adres.',
          mediaHeader: 'Plaatjes',
          mediaText1:
            'De app heeft een tweetal plaatjes nodig die bij het initiatief getoond worden. De app ziet het verschil tussen plaatje 1 en plaatje 2 door middel van het "gebruik" van het plaatje. Dit kan je aangeven bij uploaden/toevoegen.',
          mediaText2:
            'Je kan ook extra plaatjes toevoegen met het gebruik "content" deze kunnen in de omschrijving gebruikt worden.',
          mediaText3:
            'Je kan ook hetzelfde plaatje gebruiken voor "Main" en "Background" door één keer te uploaden, en de tweede keer het plaatje te zoeken.',
        },
      },
      media: {
        add: 'Toevoegen',
        edit: 'Bewerken',
        save: 'Opslaan',
        upload: 'Uploaden',
        search: 'Zoeken',
        uploadNew: 'Nieuwe bestand uploaden',
        description: 'Omschrijving',
        language: 'Taal',
        purpose: 'Gebruik',
        all: 'Alle',
        use: 'Gebruik',
        view: 'Zien',
        editShort: 'Bewerk',
        remove: 'Verwijder',
        cancel: 'Sluiten',
        uploadOrSearch:
          'Je kunt een nieuwe afbeelding uploaden of de zoekfunctie gebruiken om bestaande afbeeldingen in het CMS te gebruiken. ',
      },
      user: {
        notifications: {
          discounts: 'Discount',
          populair_initiatives: 'Popular Initiatives',
          populair_learning_item: 'Popular Learning Item',
          quiz_streak: 'Quiz',
          yes: 'Yes',
          no: 'No',
        },
      },
    },
  },
});

export default i18n;
